/* eslint-disable */
import router from '@/core/utils/router'
import store from '@/store/index'

const getALivableRedirectPatch = (aliases = store.getters['userStore/getUserRolesAccessCategories'](), isUserFullAdmin = store.getters['userStore/isUserFullAdmin']()) => {
  if (isUserFullAdmin) return false
  if (aliases?.includes('dashboard')) return 'dashboard'
  console.log(router.options.routes)
  const getAllBaseRoutes = router.options.routes.map(x => x.name).filter(x => x)
  const getAllBaseChildRoutes = router.options.routes.flatMap(x => x?.children?.map(x => x.name)).filter(x => x)
  const resultRoutes = [...getAllBaseRoutes, ...getAllBaseChildRoutes].filter(x => x)
  const getResultFiltred = resultRoutes.filter(y => aliases.includes(y))
  if (!getResultFiltred?.length) return 'Login'
  return getResultFiltred[0]
}

export { getALivableRedirectPatch }
